import { useState } from "react";
import { X, Tag } from "lucide-react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { t } from "@/lib/i18n";

export const PhotoTags = ({ photo, persons, canTag, onChange }) => {
  const [tags, setTags] = useState(photo.tagged || []);
  const save = async (next) => {
    try {
      await api.put(`/album/${photo.photo_id}/tags`, { ids: next.map((x) => x.person_id) });
      setTags(next);
      onChange?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const available = (persons || []).filter((p) => !tags.some((x) => x.person_id === p.person_id)).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <div className="space-y-2" data-testid="photo-tags">
      <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7E8E85] flex items-center gap-1"><Tag className="w-3 h-3" />{t("In this photo")}</p>
      <div className="flex flex-wrap gap-2">
        {tags.length === 0 && <span className="text-sm text-[#7E8E85]">{t("No one tagged yet.")}</span>}
        {tags.map((x) => (
          <span key={x.person_id} className="inline-flex items-center gap-1 pl-3 pr-1.5 py-1 rounded-full bg-[#F4EDE2] text-sm" data-testid={`photo-tag-${x.person_id}`}>
            <Link to={`/person/${x.person_id}`} className="hover:text-[#D96B43]">{x.name}</Link>
            {canTag && <button onClick={() => save(tags.filter((y) => y.person_id !== x.person_id))} aria-label={`Remove ${x.name}`} data-testid={`photo-tag-remove-${x.person_id}`}><X className="w-3.5 h-3.5" /></button>}
          </span>
        ))}
      </div>
      {canTag && available.length > 0 && (
        <select value="" onChange={(e) => { const p = available.find((a) => a.person_id === e.target.value); if (p) save([...tags, { person_id: p.person_id, name: p.name }]); }}
          className="h-10 rounded-xl border border-[#E5DEC9] bg-white px-3 text-sm" data-testid="photo-tag-select">
          <option value="">{t("+ Tag a relative")}</option>
          {available.map((p) => <option key={p.person_id} value={p.person_id}>{p.name}</option>)}
        </select>
      )}
    </div>
  );
};
